// extracted by mini-css-extract-plugin
export default {"frame":"frame_frame__21woa","frame_buttons":"frame_frame_buttons__vBKag","frame_button":"frame_frame_button__YLVeG"};